var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _vm._v("error"),
      _c("br"),
      _vm._v(" 您不在客莱宝的使用名单中 ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }